"use client";

import MyCard from "@/app/components/MyCard";
import { useTranslations } from "next-intl";
import React, { Suspense, useCallback, useState } from "react";
import { CLOUDFRONT_URL } from "@/constant/apiPath";
import type { INewsResponse } from "@/models/news";
import dynamic from "next/dynamic";
import { Skeleton } from "antd/lib";
import AdsBanner from "@/app/components/AdsBanner";

const MarketInsight = dynamic(() => import("@/app/components/news/MarketInsight"), { ssr: false });
const NewsBlog = dynamic(() => import("@/app/components/news/Blog"), { ssr: false });
const CTANewsSection = dynamic(() => import("@/app/components/news/CTANews"), { ssr: false });
const MainNews = dynamic(() => import("@/app/components/news/MainNews"), { ssr: false });
const MarketInsightCard = dynamic(() => import("@/app/components/MarketInsightCard"), { ssr: false });

const News = React.memo(() => {
  const t = useTranslations("news");
  const [selectedNews, setSelectedNews] = useState<INewsResponse | undefined>();

  const onClickNews = useCallback((news: INewsResponse) => {
    setSelectedNews(news);
  }, []);

  return (
    <main className="min-h-screen">
      <div className="flex flex-col gap-4">
        <AdsBanner />
        <MyCard title={<h1 className="text-lg">{t("news_analysis")}</h1>}>
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
            <div className="col-span-1 lg:col-span-3">
              <Suspense fallback={<Skeleton active />}>
                <MarketInsightCard
                  apiUrl={`${CLOUDFRONT_URL}/v1/market-insight/news/analysis`}
                  isShowImageFull
                  onClickNews={onClickNews}
                  category="Analysis"
                />
              </Suspense>
            </div>
            <div className="col-span-1 lg:col-span-6">
              <Suspense fallback={<Skeleton active />}>
                <MainNews imageClassName="max-h-[450px]" news={selectedNews} />
              </Suspense>
            </div>
            <div className="col-span-1 lg:col-span-3">
              <Suspense fallback={<Skeleton active />}>
                <MarketInsightCard
                  category="Analysis"
                  title="Most_read"
                  apiUrl={`${CLOUDFRONT_URL}/v1/market-insight/news/people`}
                />
              </Suspense>
            </div>
          </div>
        </MyCard>
        {/* <AdUnit
          slot="2782214655"
          style={{
            display: "block",
            textAlign: "center",
          }}
        /> */}
        <Suspense fallback={<Skeleton active />}>
          <MarketInsight />
        </Suspense>
        {/* <AdUnit
          slot="9349528981"
          layout="in-article"
          style={{
            display: "block",
            textAlign: "center",
          }}
        /> */}
        <Suspense fallback={<Skeleton active />}>
          <NewsBlog />
        </Suspense>
        <Suspense fallback={<Skeleton active />}>
          <CTANewsSection />
        </Suspense>
      </div>
    </main>
  );
});
News.displayName = "News";
export default News;
